import {
	btn,
	comp,
	Component,
	Config,
	createComponent,
	datasourcestore,
	DataSourceStore,
	EntityID,
	h4,
	t,
	tbar
} from "@intermesh/goui";
import {ColumnDialog} from "./ColumnDialog.js";
import {Board, boardDS, Column} from "./Index";
import {CardGrid} from "./CardGrid.js";
import {BacklogColumn} from "./BacklogColumn.js";
import {ColumnAddButton} from "./ColumnAddButton.js";

export class ColumnGrid extends Component {
	public store: DataSourceStore;
	private board: Board | undefined;
	private readonly backlogColumn: BacklogColumn;
	private readonly columnContainer: Component;

	constructor(private west: Component) {
		super();

		this.flex = 1;

		this.backlogColumn = new BacklogColumn();
		this.backlogColumn.hidden = true;
		this.items.add(this.backlogColumn);

		this.columnContainer = comp({
			cls: "hbox bg-lowest gap scroll",
			style: {padding: ".8rem"},
			flex: 1
		});

		this.items.add(
			comp({cls: "fit hbox bg-lowest"},
				comp({cls: "vbox"},
					this.createShowWestTbar(),
					this.backlogColumn
				),
				this.columnContainer
			)
		);

		this.store = datasourcestore({
			dataSource: boardDS,
			listeners: {
				load: async ev => {
					const board = ev.records[0] as Board;

					this.columnContainer.items.replace(...board.columns.map((column: Column) => {
						const columnComp = comp({
								cls: "vbox kanban-column"
							},
							tbar({cls: "border-bottom"},
								h4({
									cls: "kanban-column-title",
									text: column.label
								}),
								"->",
								new ColumnAddButton(this.board!.id, column.id!, this)
							)
						);

						const cardGrid = new CardGrid(column, board);

						cardGrid.on("cardcreatedelete", ({boardId}) => {
							this.backlogColumn.load(boardId);
						});

						columnComp.items.add(cardGrid);
						return columnComp
					}));

					const addColumnBtn = comp({}, tbar({},
						btn({
							title: t("Add column"),
							icon: "add",
							disabled: !go.Modules.get("business", "kanban").userRights.mayManageBoards,
							handler: () => {
								const dlg = new ColumnDialog(this.board!);
								dlg.show();
							}
						})
					));

					this.columnContainer.items.add(addColumnBtn);
				}
			}
		});
	}

	public async load(boardId: EntityID) {
		this.board = await boardDS.single(boardId);

		this.store.setFilter("board", {id: boardId});
		await this.backlogColumn.load(boardId);
		this.backlogColumn.hidden = false;
		void this.store.load();
	}

	private createShowWestTbar() {
		const westTbar = tbar({
				hidden: !this.west.hidden,
				cls: "border-bottom border-right border-top bg-mid",
				style: {borderBottomRightRadius: ".8rem", borderTopRightRadius: ".8rem", marginTop: ".8rem"}
			},
			"->",
			btn({
				cls: "small",
				title: t("Open sidebar"),
				icon: "left_panel_open",
				handler: (button, ev) => {
					this.west.hidden = false;
					this.west.saveState();
				}
			}))

		this.west.on("show", () => {
			westTbar.hidden = true;
		})
		this.west.on("hide", () => {
			westTbar.hidden = false;
		})

		return westTbar;
	}
}

export const columngrid = (config: Config<ColumnGrid> & {
	west: Component
}) => createComponent(new ColumnGrid(config.west), config);
